export class KeyMap {
  constructor(game, config) {
    // map default controls
    this._controlScheme = {};
    Object.keys(config.default).forEach((key) => {
      this._controlScheme[key.toUpperCase()] = config.default[key].toLowerCase();
    });

    // map local controls
    const localscheme = config[game.locale];
    if (localscheme) {
      Object.keys(localscheme).forEach((key) => {
        this._controlScheme[key.toUpperCase()] = localscheme[key].toLowerCase();
      });
    }

    game.input.keyboard.addCapture(Phaser.Input.Keyboard.KeyCodes.SPACE);
    Object.values(this._controlScheme).forEach((key) => {
      game.input.keyboard.addCapture(Phaser.Input.Keyboard.KeyCodes[key.toUpperCase()]);
    });
  }

  get controlKeyMap() {
    return { ...this._controlScheme };
  }

  getControlKey(control) {
    return this._controlScheme[control];
  }
}
